<div class="container">
  <frodo-spinner [colorSpinner]="colorSpinner" [src]="timerSrc"> </frodo-spinner>
</div>
<div class="logo">
  <frodo-logo [src]="logoSrc" (click)="refresh()"></frodo-logo>
</div>
